<template>
    <div :class="theme.panel">
        <slot></slot>
    </div>
</template>
<script>
    import theme from './panel.scss';

    export default {
        name: 'panel',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Panel.vue?41e0667a